// 常量
export const apiPrefix = 'icc/service';

// 正则
export const telPhoneReg: RegExp = /((\(0\d{2,3}\)|(0\d{2,3})-){1}[0-9]{7,8})|(^1(3|4|5|7|8)\d{9}$)/i;

export const webUrlReg: RegExp = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;
